
export const formatMoney = (amount) => {

  var formatter = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
  });

  return formatter.format(amount).replace('\$', '').trim();
};